// Lib
import { colors } from '@/lib/analytics/colors';
import { KPI_VALUE_PERCENT } from '@/hooks/format/useFormatKpiValue';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const mediaViewerCommentsOnReachConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    name: 'kpi.linkedin.mediaviewer.comments_on_reach',
    id: 'comments_on_reach',
    icon: {
        name: 'comments-on',
        style: colors.yellow
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
